const TYPE_RULES = [
  { type: 'auth', match: /token|sesion|sesión|credenciales|otp|autenticad|login|invalido|inválido/i },
  { type: 'permission', match: /privilegio|acceso|admins|administrador|prohibido|forbidden/i },
  { type: 'certificado', match: /certificado|csd|fiel|llave privada|password_certificado/i },
  { type: 'timbrado', match: /timbr|pac|sello digital|uuid|folio sat/i },
  { type: 'cliente', match: /cliente|receptor/i },
  { type: 'empresa', match: /empresa|emisor/i },
  { type: 'catalogos', match: /catalogo|catálogo/i },
  { type: 'correo', match: /correo|smtp|email/i },
  { type: 'validation', match: /campo|obligatorio|invalido|inválido|rfc|codigo postal|razon social|razón social|formulario/i },
]

function inferType(status, detail) {
  const normalizedDetail = String(detail || '')

  if (status === 401) return 'auth'
  if (status === 403) return 'permission'
  if (status === 404) return 'not-found'
  if (status === 409) return 'conflict'
  if (status === 422) return 'validation'
  if (status >= 500) return 'server'

  const match = TYPE_RULES.find((rule) => rule.match.test(normalizedDetail))
  return match?.type || 'generic'
}

export function normalizeApiError(error, fallbackMessage = 'Ocurrio un error inesperado') {
  if (!error) {
    return {
      detail: fallbackMessage,
      status: null,
      type: 'generic',
      raw: error,
    }
  }

  if (typeof error === 'string') {
    return {
      detail: error,
      status: null,
      type: inferType(null, error),
      raw: error,
    }
  }

  if (error.detail && Object.prototype.hasOwnProperty.call(error, 'type')) {
    return error
  }

  const status = error.response?.status || error.status || null
  const responseData = error.response?.data || {}
  const detail = responseData.detail || error.message || fallbackMessage

  return {
    detail,
    status,
    type: inferType(status, detail),
    raw: error,
  }
}

export function getErrorDetail(error, fallbackMessage = 'Ocurrio un error inesperado') {
  return normalizeApiError(error, fallbackMessage).detail
}